import { useQuery, UseQueryResult } from 'react-query';
import { AxiosError } from 'axios';
import { ChannelTypeInternal } from '../../../../data-access/gql-types/graphql';
import { environment } from '../../../../environment';
import { useErrors } from '../../../../hooks/errors';
import { useRestClient } from '../../../../utils/clients/rest-client';
import { tariffData, TariffItem } from './tariff.types';

export const useGetTariffs = (type: ChannelTypeInternal): UseQueryResult<TariffItem[], AxiosError> => {
  const restClient = useRestClient({ noInstallationIdHeader: true });
  const { handleRestErrors } = useErrors();

  return useQuery<TariffItem[], AxiosError>(
    'query-tariffs',
    async () => {
      const response = await restClient.get<TariffItem[]>(`/api/tariffs-${tariffData[type]}.json`, {
        baseURL: environment.PUBLIC_URL,
      });

      return response.data;
    },
    {
      enabled: true,
      retry: false,
      onError: (error: AxiosError) => {
        handleRestErrors(error);
      },
    },
  );
};
